import { PortfolioRouteShell } from '@/components/portfolio/PortfolioRouteShell';

export default function PortfolioUnified() {
  return <PortfolioRouteShell />;
}
